<div class="cotizadores-parent">
  <div class="cotizadores-container shadow">
    <img src="../../../assets/img/Homsy_text_logo.png" class="homsy-logo" />
    <img src="../../../assets/icons/circulos.svg" class="cotizadores-top-img" />
    <div class="cotizadores-space"></div>
    <div class="">
      <div class="cotizador-title">¿Qué deseas cotizar con HomSy?</div>
      <div class="items-parent">
        <div class="cotizador-buttom" (click)="resetEditItem()" [routerLink]="['/hogar']">
          <div class="cotizador-item shadow">
            <img src="../../../assets/icons/hogar.png" class="cotizador-img" style="width: 3.5rem;" />
            <div class="text" style="line-height: 14px;">Limpieza de espacios del hogar</div>
          </div>
        </div>
        <div class="cotizador-buttom" (click)="resetEditItem()" [routerLink]="['/vehiculo']">
          <div class="cotizador-item shadow">
            <img src="../../../assets/icons/camioneta.png" class="cotizador-img-vehiculo" />
            <div class="text" style="line-height: 15px; padding: 6px;">Limpieza de vehículos</div>
          </div>
        </div>
        <div class="cotizador-buttom" (click)="resetEditItem()" [routerLink]="['/muebles']">
          <div class="cotizador-item shadow">
            <img src="../../../assets/icons/sofa.png" class="cotizador-img" />
            <div class="text" style="line-height: 15px; padding: 6px;">Limpieza de tapizados</div>
          </div>
        </div>
        <div class="cotizador-buttom" (click)="resetEditItem()" [routerLink]="['/pintura']">
          <div class="cotizador-item shadow">
            <img src="../../../assets/icons/rodillo-de-pintura.png" class="cotizador-img" />
            <div class="text" style="padding: 10px;">Pintura</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>